module.exports = __webpack_public_path__ + "img/phone.6831cde7.gif";